import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Send, LayoutDashboard, Users, Mail, Settings, LogOut, Plus, Shield, FileText, Search, ShoppingBag } from 'lucide-react';
import NotificationBell from './NotificationBell';

const navItems = [
  { to: '/dashboard',         icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/campaigns',         icon: Mail,            label: 'Campaigns' },
  { to: '/leads',             icon: Users,           label: 'Leads' },
  { to: '/accounts',          icon: Send,            label: 'Email accounts' },
  { to: '/templates',         icon: FileText,        label: 'Templates' },
  { to: '/shopify-analyzer',  icon: ShoppingBag,     label: 'Store Analyzer' },
  { to: '/settings',          icon: Settings,        label: 'Settings' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isPro = user?.plan === 'pro';

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <aside style={{ width: 220, minWidth: 220, background: 'var(--bg2)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', padding: '20px 12px' }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 4px', marginBottom: 28 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden', boxShadow: '0 0 0 1px rgba(255,255,255,0.1)' }}>
            <img src="/logo.png" alt="Bulkify" style={{ width: 30, height: 30, objectFit: 'contain' }} onError={e => { e.target.parentElement.style.background = 'var(--blue)'; }} />
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.3px', lineHeight: 1 }}>Bulkify</div>
            {isPro
              ? <span style={{ fontSize: 10, color: '#fbbf24', fontWeight: 600 }}>⭐ Pro</span>
              : <span style={{ fontSize: 10, color: 'var(--text3)' }}>Free plan</span>
            }
          </div>
        </div>

        {/* New campaign */}
        <button className="btn btn-primary" style={{ width: '100%', marginBottom: 20, justifyContent: 'center' }} onClick={() => navigate('/campaigns/new')}>
          <Plus size={14} /> New campaign
        </button>

        {/* Nav */}
        <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 10px', borderRadius: 'var(--radius-sm)',
              fontSize: 13, fontWeight: 500,
              color: isActive ? 'var(--text)' : 'var(--text2)',
              background: isActive ? 'var(--bg3)' : 'transparent',
              transition: 'all 0.15s',
              textDecoration: 'none',
            })}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}

          {user?.is_admin && (
            <>
              <NavLink to="/admin" style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 10px', borderRadius: 'var(--radius-sm)',
                fontSize: 13, fontWeight: 500, marginTop: 8,
                color: isActive ? '#93c5fd' : 'var(--blue)',
                background: isActive ? 'var(--blue-dim)' : 'transparent',
                textDecoration: 'none',
              })}>
                <Shield size={16} /> Admin panel
              </NavLink>
              <NavLink to="/scraper" style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 10px', borderRadius: 'var(--radius-sm)',
                fontSize: 13, fontWeight: 500,
                color: isActive ? '#93c5fd' : 'var(--blue)',
                background: isActive ? 'var(--blue-dim)' : 'transparent',
                textDecoration: 'none',
              })}>
                <Search size={16} /> Web scraper
              </NavLink>
            </>
          )}
        </nav>

        {/* User */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--blue-dim)', color: '#93c5fd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, flexShrink: 0 }}>
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
            <div style={{ fontSize: 11, color: 'var(--text3)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.email}</div>
          </div>
          <NotificationBell />
          <button onClick={logout} style={{ background: 'none', border: 'none', color: 'var(--text3)', padding: 4, cursor: 'pointer' }}>
            <LogOut size={14} />
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, overflow: 'auto', padding: '28px 32px' }}>
        {children}
      </main>
    </div>
  );
}
